
export default {
  isHistory: '',
  sugTypeValue: 'bizoppName',
  resultSugType: 'all',
  sugNameResultData: [],
  sugLoading: false,
  pageNo: 1,
  resultLoading: false,
  sugKeyword: {
    keyword: '',
    type: 0
  },
  sugResultList: {
    total: 0,
    list: []
  },
  visitInitInfo: {},
  searchStatus: false,
  distance: 5000,
  repeatBusinessPageNo: 1,
  repeatBusinessLoading: false,
  repeatBusinessKeyword: {
    keyword: '',
    type: 0
  },
  repeatBusinessSugList: {
    total: 0,
    list: []
  }
}
